import { FormikForm } from '../../Formik'

import { SettingsFormSectionContent } from './SettingsFormSectionContent'

function SettingsFormSection({
  Buttons,
  Guard,
  after,
  bodyClassName,
  buttonsProps,
  children,
  className,
  descriptionKey,
  guardProps,
  initialValues,
  qaName,
  saveIgnoredFieldNames,
  titleKey,
  validationSchema,
  onSubmit,
}) {
  return (
    <FormikForm
      enableReinitialize
      initialValues={initialValues}
      validateOnBlur={false}
      validateOnChange={false}
      validationSchema={validationSchema}
      onSubmit={onSubmit}
    >
      <SettingsFormSectionContent
        Buttons={Buttons}
        Guard={Guard}
        bodyClassName={bodyClassName}
        buttonsProps={buttonsProps}
        className={className}
        descriptionKey={descriptionKey}
        guardProps={guardProps}
        qaName={qaName}
        saveIgnoredFieldNames={saveIgnoredFieldNames}
        titleKey={titleKey}
      >
        {children}
      </SettingsFormSectionContent>
      {after}
    </FormikForm>
  )
}

export default SettingsFormSection
